import type { NarrativeContext } from "../../narrative";
import { pick, pickDistinct, listJoin, cap, lower } from "../helpers";

/**
 * Creates an independent seeded stream under the "life" namespace.
 */
export function lifeStream(ctx: NarrativeContext, label: string): () => number {
  return ctx.stream(`life.${label}`);
}

/**
 * Returns an integer age between min and max inclusive from an rng function.
 */
export function ageFor(rng: () => number, min: number, max: number): number {
  return min + Math.floor(rng() * (max - min + 1));
}

/**
 * Clamps a level to standard 0..100 bounds.
 */
export function clampLevel(val: number, min = 0, max = 100): number {
  return Math.max(min, Math.min(max, Math.round(val)));
}

export { pick, pickDistinct, listJoin, cap, lower };
